import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInventoryForecast = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.33859 13.0963L4.00676 13.4749C4.25175 13.6085 4.5413 13.5195 4.69712 13.2745L6.30064 10.4016L9.95309 10.602C10.2871 10.6242 10.5989 10.446 10.7771 10.1566L12.7148 6.68237L16.3004 6.77139C16.5676 6.7936 16.835 6.66 17.0132 6.4596L18.4607 4.70027L19.3739 5.43521C19.6856 5.6802 20.1534 5.4798 20.1756 5.07884L20.4428 1.53778C20.465 1.18141 20.131 0.914195 19.797 1.02559L16.3672 2.02775C15.9886 2.13913 15.8773 2.65134 16.189 2.89632L17.0354 3.58668L15.8772 4.9898L12.2248 4.90062C11.8908 4.87841 11.6012 5.0566 11.4452 5.346L9.50768 8.79806L5.85523 8.59765C5.49886 8.57544 5.20945 8.75363 5.03124 9.04303L3.16051 12.3837C3.02675 12.6509 3.11593 12.9627 3.33854 13.0963L3.33859 13.0963Z",
			fill: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5097 20.468H3.58371C3.31651 20.468 3.09375 20.6908 3.09375 20.958V21.6483C3.09375 21.9155 3.31652 22.1383 3.58371 22.1383H20.5097C20.7769 22.1383 20.9997 21.9155 20.9997 21.6483V20.958C20.9997 20.6906 20.7769 20.468 20.5097 20.468Z",
			fill: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.58371 19.2207H7.70385C7.97106 19.2207 8.19382 18.9979 8.19382 18.7308V16.1474C8.19382 15.8802 7.97104 15.6575 7.70385 15.6575H3.58371C3.31651 15.6575 3.09375 15.8802 3.09375 16.1474V18.7085C3.09375 18.9981 3.31652 19.2207 3.58371 19.2207V19.2207Z",
			fill: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.97531 12.1162C9.70811 12.1162 9.48535 12.339 9.48535 12.6062V18.7084C9.48535 18.9756 9.70813 19.1984 9.97531 19.1984H14.0955C14.3627 19.1984 14.5854 18.9756 14.5854 18.7084L14.5853 12.6284C14.5853 12.3612 14.3625 12.1385 14.0953 12.1385H9.97516L9.97531 12.1162Z",
			fill: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5093 8.59741H16.3669C16.0997 8.59741 15.877 8.82019 15.877 9.08737V18.7085C15.877 18.9757 16.0997 19.1984 16.3669 19.1984H20.5093C20.7765 19.1984 20.9993 18.9757 20.9993 18.7085V9.08737C20.9993 8.82001 20.7765 8.59741 20.5093 8.59741Z",
			fill: "inherit"
		})
	]
});
export { SvgInventoryForecast as ReactComponent };
